import apiClient from './apiClient'

export const getIngresoCatalog = async (params = {}) => {
  const pageSize = params.page_size || 100
  let page = 1
  let allResults = []
  let totalCount = 0
  let hasNext = true

  while (hasNext && page <= 50) {
    const response = await apiClient.get('/ingreso-catalog/', {
      params: { ...params, page, page_size: pageSize },
    })
    const data = response.data
    const batch = Array.isArray(data) ? data : (data.results || [])
    allResults = allResults.concat(batch)
    totalCount = data.count ?? allResults.length

    hasNext = !!data.next && batch.length > 0
    page += 1
  }

  return { results: allResults, count: totalCount }
}

export const createIngresoCatalogItem = async (payload) => {
  const response = await apiClient.post('/ingreso-catalog/', payload)
  return response.data
}

export const updateIngresoCatalogItem = async (id, payload) => {
  const response = await apiClient.patch(`/ingreso-catalog/${id}/`, payload)
  return response.data
}

export const bulkImportIngresoCatalog = async (payload) => {
  const response = await apiClient.post('/ingreso-catalog/import-from-catalog/', payload)
  return response.data
}

export const deleteIngresoCatalogItem = async (id) => {
  await apiClient.delete(`/ingreso-catalog/${id}/`)
}

export { quoteIngresoShipping, getShippingPublicConfig } from '@/services/shipping'
